import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CodeEditor from "../../../Components/CodeEditor";
import { submitForm } from "../../../utils/apiUtils";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../helper/ImageFormat";
import UploadMultiImage from "../../../Components/UploadMultiImage";

const AddCms = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const editingId = editData?.id;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        title: editData?.title || "",
        description: editData?.description || "",
        url: editData?.url || "",
        meta_title: editData?.meta_title || "",
        meta_keyword: editData?.meta_keyword || "",
        meta_description: editData?.meta_description || "",
        isActive: editData?.isActive ?? true,
        position: editData?.position || editData?.nextPosition,
        image: editData?.image || [],
    });

    const [errors, setErrors] = useState({
        title: "",
        description: "",
        url: "",
        meta_title: "",
        meta_keyword: "",
        meta_description: "",
        position: ""
    });

    const handleChange = (e) => {
        const { name, files, checked, value } = e.target;
        if (name === "desktopImg" || name === "mobileImg") {
            const imageData = files?.length > 0 ? files[0] : editData[name];
            setData({ ...data, [name]: imageData });
        } else if (name === "isActive") {
            setData({ ...data, [name]: checked });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await submitForm({
            data,
            url: "/cms",
            editingId,
            validateFields: [
                { name: "title", message: "Title is required" },
                { name: "description", message: "Description is required" },
                { name: "meta_title", message: "Meta title is required" },
                { name: "meta_keyword", message: "Meta keyword is required" },
                { name: "meta_description", message: "Meta description is required" },
                { name: "position", message: "Sort order is required" },
            ],
            validationErrorsSetter: setErrors,
            navigate: () => navigator("/cms"),
        });
        setLoading(false);
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5 mx-4">
                    <h3 className="page-title">{editData?.id ? "Update" : "Add"} CMS </h3>
                </div>
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername2" className="col-form-label">
                                                    Page Title
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`border border-dark form-control form-control-sm`}
                                                    id="title"
                                                    name="title"
                                                    placeholder="Enter title"
                                                    value={data.title}
                                                    onChange={handleChange}
                                                />
                                                {errors.title && (
                                                    <small className="text-danger">{errors.title}</small>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername2" className="col-form-label ">
                                                    SortOrder
                                                </label>
                                                <input
                                                    type="number"
                                                    className={`border border-dark form-control form-control-sm`}
                                                    id="position"
                                                    name="position"
                                                    placeholder="Enter sort order"
                                                    value={data.position}
                                                    onChange={handleChange}
                                                />
                                                {errors.position && (
                                                    <small className="text-danger">{errors.position}</small>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername2" className="col-form-label">
                                                    URL
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`border border-dark form-control form-control-sm`}
                                                    id="url"
                                                    name="url"
                                                    placeholder="Enter url"
                                                    value={data.url}
                                                    onChange={handleChange}
                                                />
                                                {errors.url && <small className="text-danger">{errors.url}</small>}
                                            </div>
                                        </div>

                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername2" className="col-form-label">
                                                    Description
                                                </label>
                                                <CodeEditor
                                                    value={data.description}
                                                    style={{ height: "400px" }}
                                                    onChange={(value) =>
                                                        handleChange({
                                                            target: {
                                                                name: "description",
                                                                value,
                                                            },
                                                        })
                                                    }
                                                />
                                                {errors.description && !data?.description?.trim() && (
                                                    <small className="text-danger">Description is required</small>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername2" className="col-form-label">
                                                    Meta Title
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`border border-dark form-control form-control-sm `}
                                                    id="meta_title"
                                                    name="meta_title"
                                                    placeholder="Enter  meta title"
                                                    value={data.meta_title}
                                                    onChange={handleChange}
                                                />
                                                {errors.meta_title && (
                                                    <small className="text-danger">{errors.meta_title}</small>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername2" className="col-form-label">
                                                    Meta Keyword
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`border border-dark form-control form-control-sm`}
                                                    id="meta_keyword"
                                                    name="meta_keyword"
                                                    placeholder="Enter meta keyword"
                                                    value={data.meta_keyword}
                                                    onChange={handleChange}
                                                />
                                                {errors.meta_keyword && (
                                                    <small className="text-danger">{errors.meta_keyword}</small>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername2" className="col-form-label">
                                                    Meta description
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`border border-dark form-control form-control-sm `}
                                                    id="meta_description"
                                                    name="meta_description"
                                                    placeholder="Enter meta description"
                                                    value={data.meta_description}
                                                    onChange={handleChange}
                                                />
                                                {errors.meta_description && (
                                                    <small className="text-danger">{errors.meta_description}</small>
                                                )}
                                            </div>
                                        </div>




                                        <div className="col-md-12 mt-4 p-2" >
                                            <SwitchToggle
                                                checked={data.isActive}
                                                onChange={(val) => setData((prev) => ({ ...prev, isActive: val }))}
                                            />
                                        </div>

                                        <div className="mt-5 w-100 p-2">
                                            <UploadMultiImage
                                                initialImages={data.image}
                                                onChange={(imagesArray) =>
                                                    setData((prev) => ({ ...prev, image: imagesArray }))
                                                }
                                                apiUrl={"multi/upload-media?label=other"}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">

                                        <Button type="submit" color="primary" disabled={loading}>
                                            {loading ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    {editData?.id ? "Updating..." : "Submitting..."}
                                                </>
                                            ) : editData?.id ? (
                                                "Update"
                                            ) : (
                                                "Add"
                                            )}
                                        </Button>

                                        <Link to="/cms">
                                            <Button color="danger" className="ml-3">Cancel</Button>
                                        </Link>


                                    </div>
                                </form>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddCms;
